export default __webpack_public_path__ + "static/media/step7_img2.a505a387.png";